;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();export const IS_EPS_CARD_MAINTENANCE_ACTIVE = false;

export const CARD_MAINTENANCE_TITLE = 'Scheduled card maintenance';

export const CARD_MAINTENANCE_DESCRIPTION =
  'We’ll be carrying out scheduled card maintenance overnight, starting at 21:00 (GMT+3).';

export const CARD_MAINTENANCE_DETAILS =
  'You can continue using your card for payments and ATM withdrawals as usual. However, your card balance and transactions may take longer to appear on the platform. Everything will update once maintenance is complete.';

export const CARD_MAINTENANCE_DISABLED_MESSAGE =
  'Temporarily unavailable during scheduled maintenance.';
